import { render } from "./documentListItem.vue?vue&type=template&id=a3bd377c&scoped=true"
import script from "./documentListItem.vue?vue&type=script&lang=js"
export * from "./documentListItem.vue?vue&type=script&lang=js"

import "./documentListItem.vue?vue&type=style&index=0&id=a3bd377c&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/prod-hys-h5-5.0/hys-h5-5.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3bd377c"]])

export default __exports__